import React from 'react';
import PropTypes from 'prop-types';

import { getModifiers } from '@/shared/ui/core';

import Button, { ButtonGroup } from './Button.styled';

import SpinnerPath from '@/shared/assets/icons/icon-loading.svg';

const modifierProps = ['primary', 'disabled', 'secondary', 'textButton', 'loading'];
const DEBOUNCE_TIME = 500;

export default ({
  children,
  content,
  label,
  onClick,
  modifiers,
  ...props
}) => {
  const debounce = React.useRef(null);
  const handleClick = (event) => {
    if (typeof onClick !== 'function') {
      return;
    }

    if (!debounce.current) {
      debounce.current = true;
      onClick(event);
      setTimeout(() => {
        debounce.current = false;
      }, DEBOUNCE_TIME);
    } else {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  return (
    <Button
      modifiers={getModifiers({ ...props, modifiers }, modifierProps)}
      onClick={handleClick}
      role="button"
      {...props}
    >
      {modifiers?.includes('loading') ? (
        <SpinnerPath />
      ) : (
        children || label || content
      )}
    </Button>
  );
};

Button.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  label: '',
  onClick: () => {},
};

export { ButtonGroup };
